import { DomainModelHelper } from '@digital-platform/shared/domain';
import { Attachment } from '../interfaces/attachment.interface';

export class AttachmentModel implements Attachment {
  public readonly id: string;
  public readonly fileName: string;
  public readonly fileType: string;
  public readonly fileSize: number;
  public readonly fileUrl: string;
  public readonly uploadDate?: Date;

  public static DEFAULT_CONFIG: Attachment = {
    id: null,
    fileName: '',
    fileType: '',
    fileSize: -1,
    fileUrl: '',
    uploadDate: null,
  };

  public constructor(data?: Attachment) {
    Object.assign(this, AttachmentModel.DEFAULT_CONFIG);

    if (data?.id !== undefined) {
      this.id = DomainModelHelper.ensureDataIsString(data.id);
    }
    if (data?.fileName !== undefined) {
      this.fileName = DomainModelHelper.ensureDataIsString(data.fileName);
    }
    if (data?.fileType !== undefined) {
      this.fileType = DomainModelHelper.ensureDataIsString(data.fileType);
    }
    if (data?.fileSize !== undefined) {
      this.fileSize = DomainModelHelper.ensureDataIsNumber(data.fileSize);
    }
    if (data?.fileUrl !== undefined) {
      this.fileUrl = DomainModelHelper.ensureDataIsString(data.fileUrl);
    }
    if (data?.uploadDate !== undefined) {
      this.uploadDate = DomainModelHelper.ensureDataIsDate(data.uploadDate);
    }
  }
}
